// NOTE: this file was auto-generated with `libraries/icons/src/_private/transform.ts`
// Any manual edits will be overwritten via `rush build`

import { SVGProps } from 'react';

const Radio = (props: SVGProps<SVGSVGElement>) => (
	<svg xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" viewBox="0 0 96 96" {...props}>
		<path
			d="M64.071 64.063a2 2 0 0 1-2-2V33.936a2 2 0 0 1 4 0v28.126a2 2 0 0 1-2 2m-53.57 1.561a2 2 0 0 1-2-1.998v-31.25a2 2 0 1 1 4 0v31.25a2 2 0 0 1-2 1.998m42.856 5.47a2 2 0 0 1-2-2V26.907a2 2 0 0 1 4 0v42.187a2 2 0 0 1-2 2m21.43 0a2 2 0 0 1-2-2V26.907a2 2 0 1 1 4 0v42.187a2 2 0 0 1-2 2M21.213 75a2 2 0 0 1-2-2V22.998a2 2 0 0 1 4 0v50.002a2 2 0 0 1-2 2M85.5 80.999a2 2 0 0 1-2-1.998V16.998a2 2 0 0 1 4 0v62.002a2 2 0 0 1-2 1.998m-42.858 2.205a2 2 0 0 1-2-2V14.797a2 2 0 0 1 4 0v66.407a2 2 0 0 1-2 2M31.928 87.5a2 2 0 0 1-2-2v-75a2 2 0 0 1 4 0v75a2 2 0 0 1-2 2"
			fillRule="evenodd"
		/>
	</svg>
);
export default Radio;
